import { render, staticRenderFns } from "./QuestionForm3.vue?vue&type=template&id=7adfd18f&scoped=true&"
import script from "./QuestionForm3.vue?vue&type=script&lang=js&"
export * from "./QuestionForm3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adfd18f",
  null
  
)

export default component.exports